module.exports = __webpack_public_path__ + "img/arrow-alt-circle-down.8114a11c.svg";